import type { EdgeOptions, NodeOptions, BrowserOptions } from '@sentry/nextjs';

declare global {
    interface Window {
        // merge in ContentSquare-to-Sentry integration types in global Window type
        CS_CONF: {
            integrations_handler: {
                sentry?: (event) => void;
            };
        };
        _uxa: unknown[];
    }
}

const SharedSentryOptions: BrowserOptions | NodeOptions | EdgeOptions = {
    beforeBreadcrumb(breadcrumb) {
        const maxSize = 5000; // 5000 characters limit
        if (breadcrumb?.message && breadcrumb.message?.length > maxSize) {
            breadcrumb.message = breadcrumb.message.slice(0, maxSize);
            breadcrumb.message += '\n [... Truncated to 5000 characters]';
        }
        return breadcrumb;
    },
    beforeSend(event) {
        /*
         * Name: Sentry / Contentsquare Integration
         * Version: 1.0.0
         */
        (function () {
            // eslint-disable-next-line no-var
            var eventPayload = event;

            function csCallback() {
                if (!disableCallback) {
                    disableCallback = true;

                    const sentryFunc =
                        window.CS_CONF?.integrations_handler?.sentry;
                    if (sentryFunc) {
                        sentryFunc(eventPayload);
                    }
                }
            }
            // eslint-disable-next-line no-var
            var disableCallback = false;
            window._uxa = window._uxa || [];
            window._uxa.push(['afterPageView', csCallback]);
        })();

        const maxSize = 5000; // 5000 characters limit
        let message = event?.message || '';

        if (event?.exception?.values?.length) {
            event.exception.values.forEach(exception => {
                if (exception.value && exception.value.length > maxSize) {
                    let exceptionMessage = exception.value;
                    exceptionMessage = exceptionMessage.slice(0, maxSize);
                    exceptionMessage += '\n [... Truncated to 5000 characters]';
                    exception.value = exceptionMessage;
                }
            });
        }

        // Check if the message exceeds max size
        if (message.length > maxSize) {
            message = message.slice(0, maxSize);
            message += '\n [... Truncated to 5000 characters]';
            event.message = message;
        }

        // Returning modified event
        return event;
    },
    tracePropagationTargets: [/\/api\//],
};

export default SharedSentryOptions;
